<template>
  <div class="product-item">
    <div class="logo-block">
      <img :src="product.bankLogo" />
    </div>
    <div class="content-block">
      <div class="product-name">{{ product.name }}</div>
      <div class="product-attrs">
        <div>
          <span>年息范围：</span>
          <span>{{ annualInterestRange }}</span>
        </div>
        <div>
          <span>审批时间：</span>
          <span>{{ acceptanceTime }}</span>
        </div>
      </div>
      <div class="product-amount">￥{{ product.quotaRangeEnd || 0 }}万元以下</div>
    </div>
  </div>
</template>

<script>
import { judgeAnnualInterestRange } from '@/utils/judge'
export default {
  name: 'ProductItem',
  props: {
    product: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    acceptanceTime() {
      return this.product.acceptanceTimeStart + '~' + this.product.acceptanceTimeEnd + '个工作日'
    },
    annualInterestRange() {
      return judgeAnnualInterestRange(
        this.product.annualInterestRangeStart,
        this.product.annualInterestRangeEnd
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.product-item {
  width: 33.33%;
  height: 280px;
  padding: 20px;
  box-sizing: border-box;
  background: #fff;
  border-right: 1px #eee solid;
  border-bottom: 1px #eee solid;
  text-align: left;

  &:nth-of-type(3n) {
    border-right: 0px;
  }

  .logo-block {
    width: 100%;
    height: 150px;
    position: relative;
    @include displayCenter;

    img {
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
    }
  }

  .content-block {
    display: flex;
    flex-direction: column;

    .product-name {
      font-size: 17px;
      color: #000;
      @extend %single-line-hidden;
      margin-top: 4px;
    }

    .product-attrs {
      font-size: 14px;
      color: #999;
      @extend %single-line-hidden;
      margin-top: 4px;
    }

    .product-amount {
      font-size: 18px;
      font-weight: 600;
      color: #f96600;
      margin-top: 4px;
    }
  }
}

%single-line-hidden {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
